export default __webpack_public_path__ + "media/images/compte-rendu-513e74b601ef16e3e83048df5d637a84.png";